<template>
    <div class="admin_main_wrapper">
        <customModalDialog :settings="customModalSettings"></customModalDialog>

        <b-list-group class="profiles_list"
                      v-if="this.closeAccounts.length"
        >
            <b-list-group-item
                    v-for="(item, index) in this.closeAccounts"
                    :key="index"
                    class="closeAccounteItem"
            >
                <div class="control-panel">
                    <b-button @click="onDecline(item)"
                            class="onDeclineItem"
                            variant="success"
                    >
                        {{translate('Decline')}}
                    </b-button>

                    <b-button @click="onApprove(item)"
                            class="onApproveItem"
                            variant="danger"
                    >
                        {{translate('Approve')}}
                    </b-button>
                </div>
                <div class="body">
                    <div class="top">
                        <span class="name">{{item.user.first_name}} {{item.user.last_name}}</span>
                        <span class="email">email: {{item.user.email}}</span>
                    </div>
                    <div class="bottom">
                        <span class="uid" title="UID">uid: {{item.uid}}</span>
                        <span class="date" title="created"> date: {{item.created | moment("HH:mm:ss D.MM.YYYY ")}}</span>
                    </div>
                    <span class="name"></span>
                </div>

            </b-list-group-item>
        </b-list-group>
        <div
                v-else-if="spinner"
                class="info-status"
        >
            <b-spinner small></b-spinner>
        </div>
        <div
                v-else
                class="info-status"
        >
            {{translate('NoData')}}
        </div>
        <infinite-loading :identifier="infinity" @infinite="fetchData">
            <div slot="no-more"></div>
            <div slot="no-results"></div>
        </infinite-loading>
    </div>
</template>

<script>
    import {mapActions, mapMutations, mapState} from "vuex";
    import InfiniteLoading from "vue-infinite-loading";
    import customModalDialog from '@/components/widgets/customModalDialog';
    import errorMixin from "@/mixins/errorMixin";
    import adminPageMixin from "@/mixins/adminPageMixin";


    export default {
        mixins: [errorMixin, adminPageMixin],
        name: 'closeAccountRequest',

        components: {
            InfiniteLoading,
            customModalDialog
        },

        data() {
            return {
                page: 1,
                spinner: true,
                closeAccounts: [],
                customModalSettings: {},
            }
        },

        props: ['infinity'],

        watch: {
            infinity(val){
                this.page = 1
            }
        },
        mounted() {
            this.initAdminPage()
        },

        methods: {

            ...mapActions({
                fetchAccountsAction: 'closeAccount/fetchAccounts',
                approveRequestAction: 'closeAccount/approveRequest',
                declineRequestAction: 'closeAccount/declineRequest',
            }),

            async fetchData(stateInf){
                this.spinner = true
                try {
                    const response = await this.fetchAccountsAction({
                        page: this.page
                    });
                    if (response.success) {
                        if (this.page == 1) {
                            this.closeAccounts = []
                        }
                        this.page += 1
                        console.log(response)
                        response.collection.forEach((item) => {
                            this.closeAccounts.push(item)
                        })
                        if (stateInf) {
                            if (response.collection.length === 10) {
                                stateInf.loaded();
                            } else {
                                stateInf.complete();
                            }
                        }
                    } else {
                        this.showErrorModal()
                    }
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                    this.spinner = false
                }
            },

            onApprove(item){
                this.customModalSettings = {
                    message: this.translate('ApproveRequest'),
                    onOkHandler: this.approveRequest.bind(null, item),
                    showCancelButton: true,
                    okButtonText: this.translate('yes'),
                    cancelButtonText: this.translate('no'),
                }
            },

            async approveRequest(item){
                try {
                    await this.approveRequestAction(item);
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                }
            },

            onDecline(item){
                this.customModalSettings = {
                    message: this.translate('DeclineRequest'),
                    onOkHandler: this.declineRequest.bind(null, item),
                    showCancelButton: true,
                    okButtonText: this.translate('yes'),
                    cancelButtonText: this.translate('no'),
                }
            },

            async declineRequest(item){
                try {
                    await this.declineRequestAction(item);
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                }
            },

        }

    }
</script>

<style scoped>

    .profiles_list {
        max-height: calc(100vh - 62px);
        overflow: auto;
    }
    .control-panel button {
        margin-right: 7px;
        font-size: 12px;
    }

    .body {
        font-size: 12px;
    }
    .body .bottom {
        border-top: 1px solid #fff;
    }

    .body span {
        display: block;
    }

    .body span.name {
        font-size: 14px;
        color: #000;
        font-weight: 500;
    }

    .info-status {
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%);
        width: 90vw;
    }

</style>
